import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSidebarFloating"><Path fillRule="evenodd" clipRule="evenodd" d="M22.25 3.75V20.25H1.75V3.75H22.25ZM14.5 10.5V16.5H18.5V10.5H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
